let site='ccje23test';
// let site='ccje23formal';
// let site='local';
let appConfig={okapiHost:'',serviceHost:'',XOkapiTenant:'',ossUploadHost:''};
const bjConfig={
    okapiHost:'http://222.29.81.147/okapi/bl-users/login', //远程okapi地址
    serviceHost:'http://222.29.81.147/okapi/api/ccje/', //后台服务地址
    XOkapiTenant:'testlib',
    ossUploadHost: 'http://222.29.81.147:9001/'
};

const hbConfig={
    okapiHost:'http://192.168.0.250:9130/bl-users/login', //远程okapi地址
    serviceHost:'http://192.168.0.250:8882/api/ccje/', //后台服务地址
    XOkapiTenant:'userlib',
    ossUploadHost: 'http://222.29.81.147:9001/'
};
// const localConfig={
//     okapiHost:'http://222.29.81.147:9130/bl-users/login', //远程okapi地址
//     serviceHost:'http://localhost:8882/api/ccje/', //后台服务地址
//     XOkapiTenant:'testlib',
    // okapiHost:'http://162.105.134.111:9130/bl-users/login', //远程okapi地址 okapiHost:'http://222.29.81.147/okapi/bl-users/login', //远程okapi地址
    // okapiHost:'http://222.29.81.147/okapi/bl-users/login', //远程okapi地址
// };
const localConfig={
    okapiHost:'http://162.105.134.98:9130/bl-users/login', //远程okapi地址
    serviceHost:'http://localhost:8882/api/ccje/', //后台服务地址
    serviceHost2:'http://localhost:8090/', //后台服务地址
    XOkapiTenant:'testlib',
    ossUploadHost: 'http://222.29.81.147:9001/'
};
const bjlConfig={
    okapiHost:'http://222.29.81.147:9130/bl-users/login', //远程okapi地址
    serviceHost:'http://localhost:8882/api/ccje/', //后台服务地址
    XOkapiTenant:'testlib',
    ossUploadHost: 'http://222.29.81.147:9001/'
};
const yxzConfig={
    okapiHost:'http://222.29.81.147:9130/bl-users/login', //远程okapi地址
    serviceHost:'http://192.168.0.118:8882/api/ccje/', //后台服务地址
    XOkapiTenant:'testlib',
    ossUploadHost: 'http://222.29.81.147:9001/'
};
const ccje23FormalConfig={ // 23版正式系统配置
    okapiHost:'http://162.105.138.235/okapi/bl-users/login', //远程okapi地址
    // serviceHost:'https://ccje.lib.pku.edu.cn/okapi/api/ccje/', //后台服务地址
    serviceHost:'http://162.105.138.235/okapi/api/ccje/', //后台服务地址
    serviceHost2:'http://162.105.138.235/bookorder/', //后台服务地址
    XOkapiTenant:'testlib',
    ossUploadHost: 'http://162.105.138.235:9001/'
};
// const ccje23TestConfig={ // 23版专家系统配置
//     okapiHost:'http://ccj.lib.pku.edu.cn/okapi/bl-users/login', //远程okapi地址
//     // serviceHost:'https://ccj.lib.pku.edu.cn/okapi/api/ccje/', //后台服务地址
//     serviceHost:'http://ccj.lib.pku.edu.cn/okapi/api/ccje/', //后台服务地址
//     XOkapiTenant:'testlib',
//     ossUploadHost: 'http://162.105.138.236:9001/'
// };

const ccje23TestConfig={ // 23版测试系统配置
    okapiHost:'http://162.105.138.236/okapi/bl-users/login', //远程okapi地址
    // serviceHost:'https://ccj.lib.pku.edu.cn/okapi/api/ccje/', //后台服务地址
    serviceHost:'http://162.105.138.236/okapi/api/ccje/', //后台服务地址
    serviceHost2:'http://162.105.138.236/bookorder/', //后台服务地址
    XOkapiTenant:'testlib',
    ossUploadHost: 'http://162.105.138.236:9001/'
};

export const version2017={
    host:'http://222.29.77.109:9130/api/ccje/',
    XOkapiTenant:'testlib',
    token:'eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJndW9taCIsInVzZXJfaWQiOiJndW9taElkIiwidGVuYW50IjoidGVzdGxpYiJ9.w7sorTnioP5YPbMb05-XXqNUFm98Filb8Vl3T4bFW0XAW_I_ATfB2N8qDKyaqPwX4S6sCAjsu67ujaOXyZpthw'
};

export const version2020={
    host:'http://222.29.81.147:9130/api/ccje/',
    XOkapiTenant:'testlib',
    token:'eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJ3ZWljZiIsInVzZXJfaWQiOiJ3ZWljZklkIiwidGVuYW50IjoidGVzdGxpYiJ9.EpUlsOeFrHybaKTJU_4owyh7EbKhy-VuWskP8t-LAvjQz_k3SUYCYFb5wop06iJ6mdgmPwQcF9jy1Ti62tAisQ'
};

switch (site) {
    case 'hb':
        appConfig=hbConfig;
        break;
    case 'bj':
        appConfig=bjConfig;
        break;
    case 'local':
        appConfig=localConfig;
        break;
    case 'bjl':
        appConfig=bjlConfig;
        break;
    case 'yxz':
        appConfig=yxzConfig;
        break;
    case 'ccje23formal':
        appConfig=ccje23FormalConfig;
        break;
    case 'ccje23test':
        appConfig=ccje23TestConfig;
        break;
}
export default appConfig;


// WEBPACK FOOTER //
// src/config/appConfig.js